/**
 * FrontDesk Design System
 *
 * Complete design system for consistent UI across FrontDesk feature
 *
 * @example
 * ```tsx
 * import { tokens, Avatar, Button, ConversationListItem, ThreeColumnLayout } from '@/widgets/frontdesk/design-system';
 *
 * // Use tokens directly
 * const primaryColor = tokens.colors.primary[600];
 *
 * // Use primitive components
 * <Avatar name="John Doe" size="md" presence="online" />
 *
 * // Use compound components
 * <ConversationListItem
 *   title="Email Subject"
 *   participants={["user@email.com"]}
 *   snippet="Preview text..."
 *   timestamp="2 min ago"
 * />
 *
 * // Use layouts
 * <ThreeColumnLayout
 *   navigationContent={<Nav />}
 *   listContent={<List />}
 *   mainContent={<Content />}
 * />
 * ```
 */

// Types
export * from './types';

// Tokens
export * from './tokens';

// Primitives
export * from './primitives';

// Compounds
export * from './compounds';

// Components (specialized)
export * from './components';

// Layouts
export * from './layouts';

// Styles (reusable style patterns)
export * from './styles';

// Utilities
export { default as themeConfig } from './theme';